module.exports = __webpack_public_path__ + "static/media/edit.84eea3d0.svg";